import { Skeleton } from '@ths/ui';

export function SavedCardsSkeleton({
  withAction = false,
}: {
  withAction?: boolean;
}) {
  return (
    <div
      role="status"
      aria-label="Loading payment methods"
      className="space-y-4"
    >
      <span className="sr-only">Loading payment methods</span>
      <div className="flex items-center gap-4 rounded-md border border-separator p-4">
        <Skeleton className="size-5 shrink-0 rounded-full" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-5 w-44 max-w-full" />
          <Skeleton className="h-4 w-56 max-w-full" />
        </div>
      </div>
      {withAction && <Skeleton className="h-10 w-28" />}
    </div>
  );
}
